<template>
  <div class="fleet-outcome">
    <div class="image"><img :src="productImageUrl" :alt="titleText" /></div>
    <div class="text">
      <div class="intro">Based on your answers Fleet® recommends</div>
      <h3><i class="fa fa-check"></i> {{ titleText }}</h3>
      <div class="content" v-html="description"></div>
      <div class="product-disclaimer" v-if="productDisclaimer">
        {{ productDisclaimer }}
      </div>
      <div class="ctas">
        <a :href="productUrl" class="button button-product">Learn More</a>
        <a :href="wtbUrl" class="button button-wtb">Where to Buy</a>
      </div>
      <div class="actions">
        <div>
          <img
            src="@/assets/your-relief-solution.png"
            alt="Your relief solution, powered by Fleet®"
          />
        </div>
        <div><restart-button /></div>
      </div>
    </div>
  </div>
</template>

<script>
import RestartButton from '@/components/RestartButton'

export default {
  name: 'fleet-outcome',
  components: { RestartButton },
  props: {
    outcome: {
      type: Object,
      required: true
    }
  },
  computed: {
    titleText() {
      return this.$props.outcome.titleText
    },
    productUrl() {
      return this.$props.outcome.productUrl
    },
    wtbUrl() {
      return this.$props.outcome.wtbUrl
    },
    description() {
      return this.$props.outcome.description
    },
    productImageUrl() {
      return require(`@/assets/${this.$props.outcome.productImageUrl}`)
    },
    productDisclaimer() {
      return this.$props.outcome.disclaimer
    }
  }
}
</script>
